import React from 'react';
import { translate } from 'react-i18next';

import {Button, Form, Input, Grid, Header, Message, Label, Segment, Modal, Checkbox, Dropdown} from 'semantic-ui-react';
import {colors, fontSizes, fonts, shadow} from 'style';

var style = {
    buttonWrapper: {
        textAlign: 'center',
    },
    container: {
        padding: '10px 5px 10px 5px',
    },
    button: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: colors.themeBlue,
        color: '#fff',
        width: '300px',
        boxShadow: shadow,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
}


const EditTime = ({t, 
                   time, 
                   onSubmit, 
                   onClose, 
                   options, 
                   hour, 
                   minute, 
                   ampm, 
                   updateTime}) => (
        <Modal closeIcon open size="mini" onClose={onClose}>
        <Modal.Header>{t('Time')}</Modal.Header>
        <Modal.Content>
            <Form onSubmit={()=>onSubmit(time)}>
                <div style={style.container}>
                    <Dropdown name='hour'   value={hour}   options={options.hour}   selection compact onChange={updateTime} />
                    <Dropdown name='minute' value={minute} options={options.minute} selection compact onChange={updateTime} />
                    <Dropdown name='ampm'   value={ampm}   options={options.ampm}   selection compact onChange={updateTime} />
                </div>
                <br />
                <br />
                <div style={style.buttonWrapper}>
                    <Button style={style.button} type='submit'>{t('Confirm')}</Button>    
                </div>
            </Form>
        </Modal.Content>
      </Modal>
  );

export default translate('categories')(EditTime);



// WEBPACK FOOTER //
// ./src/modules/categories/EditTime.js